module.exports = __webpack_public_path__ + "officialStatic/img/product-odn.ca0f590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-odn.png
// module id = citK
// module chunks = 0